import {GridItemType} from "../../types";

export function isArrayEmpty(array: GridItemType[][]): boolean {
    for (const row of array) {
        for (const element of row) {
            if (element.item && Object.keys(element.item).length > 0) {
                return false;
            }
        }
    }
    return true;
}